function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:none;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "two_three"
}, /*#__PURE__*/React.createElement("path", {
  d: "M60.9,138.8c2,7.3,7.4,9.4,7.3,14.3c0,2.3-1.6,3.7-3.7,3.7c-2,0-3.7-1.6-3.7-3.7c0,2-1.6,3.7-3.7,3.7s-3.7-1.3-3.7-3.7 C53.5,148.2,58.9,146.2,60.9,138.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61,53.5c2-7.3,7.4-9.4,7.3-14.3c0-2.3-1.6-3.7-3.7-3.7c-2,0-3.7,1.6-3.7,3.7c0-2-1.6-3.7-3.7-3.7s-3.7,1.3-3.7,3.7 C53.6,44.2,59,46.2,61,53.5z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "three_nine_five_nine"
}, /*#__PURE__*/React.createElement("path", {
  d: "M60.9,103.8c2-7.3,7.4-9.4,7.3-14.3c0-2.3-1.6-3.7-3.7-3.7c-2,0-3.7,1.6-3.7,3.7c0-2-1.6-3.7-3.7-3.7s-3.7,1.3-3.7,3.7 C53.5,94.5,58.9,96.5,60.9,103.8z"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "four_five_six_seven_eight_nine_ten"
}, /*#__PURE__*/React.createElement("path", {
  d: "M45.9,138.8c2,7.3,7.4,9.4,7.3,14.3c0,2.3-1.6,3.7-3.7,3.7c-2,0-3.7-1.6-3.7-3.7c0,2-1.6,3.7-3.7,3.7s-3.7-1.3-3.7-3.7 C38.5,148.2,43.9,146.2,45.9,138.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M75.9,138.8c2,7.3,7.4,9.4,7.3,14.3c0,2.3-1.6,3.7-3.7,3.7s-3.7-1.6-3.7-3.7c0,2-1.6,3.7-3.7,3.7s-3.7-1.3-3.7-3.7 C68.5,148.2,73.9,146.2,75.9,138.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.9,53.5c2-7.3,7.4-9.4,7.3-14.3c0-2.3-1.6-3.7-3.7-3.7c-2,0-3.7,1.6-3.7,3.7c0-2-1.6-3.7-3.7-3.7s-3.7,1.3-3.7,3.7 C38.5,44.2,43.9,46.2,45.9,53.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M75.9,53.5c2-7.3,7.4-9.4,7.3-14.3c0-2.3-1.6-3.7-3.7-3.7s-3.7,1.6-3.7,3.7c0-2-1.6-3.7-3.7-3.7s-3.7,1.3-3.7,3.7 C68.5,44.2,73.9,46.2,75.9,53.5z"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "seven"
}, /*#__PURE__*/React.createElement("path", {
  d: "M61,78.8c2-7.3,7.4-9.4,7.3-14.3c0-2.3-1.6-3.7-3.7-3.7c-2,0-3.7,1.6-3.7,3.7c0-2-1.6-3.7-3.7-3.7s-3.7,1.3-3.7,3.7 C53.6,69.5,59,71.5,61,78.8z"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  id: "eight"
}, /*#__PURE__*/React.createElement("path", {
  d: "M61,110.8c2,7.3,7.4,9.4,7.3,14.3c0,2.3-1.6,3.7-3.7,3.7c-2,0-3.7-1.6-3.7-3.7c0,2-1.6,3.7-3.7,3.7s-3.7-1.3-3.7-3.7 C53.6,120.2,59,118.2,61,110.8z"
}));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  id: "six_seven_eight"
}, /*#__PURE__*/React.createElement("path", {
  d: "M45.7,104.4c2-7.3,7.4-9.4,7.3-14.3c0-2.3-1.6-3.7-3.7-3.7s-3.7,1.6-3.7,3.7c0-2-1.6-3.7-3.7-3.7c-2,0-3.7,1.3-3.7,3.7 C38.2,95,43.7,97.1,45.7,104.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M75.7,104.4c2-7.3,7.4-9.4,7.3-14.3c0-2.3-1.6-3.7-3.7-3.7c-2,0-3.7,1.6-3.7,3.7c0-2-1.6-3.7-3.7-3.7s-3.7,1.3-3.7,3.7 C68.2,95,73.7,97.1,75.7,104.4z"
}));

var _ref9 = /*#__PURE__*/React.createElement("g", {
  id: "nine_ten"
}, /*#__PURE__*/React.createElement("path", {
  d: "M45.7,103.4c2,7.3,7.4,9.4,7.3,14.3c0,2.3-1.6,3.7-3.7,3.7s-3.7-1.6-3.7-3.7c0,2-1.6,3.7-3.7,3.7c-2,0-3.7-1.3-3.7-3.7 C38.2,112.8,43.7,110.7,45.7,103.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M75.7,103.4c2,7.3,7.4,9.4,7.3,14.3c0,2.3-1.6,3.7-3.7,3.7c-2,0-3.7-1.6-3.7-3.7c0,2-1.6,3.7-3.7,3.7s-3.7-1.3-3.7-3.7 C68.2,112.8,73.7,110.7,75.7,103.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.7,87.4c2-7.3,7.4-9.4,7.3-14.3c0-2.3-1.6-3.7-3.7-3.7s-3.7,1.6-3.7,3.7c0-2-1.6-3.7-3.7-3.7c-2,0-3.7,1.3-3.7,3.7 C38.2,78,43.7,80.1,45.7,87.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M75.7,87.4c2-7.3,7.4-9.4,7.3-14.3c0-2.3-1.6-3.7-3.7-3.7c-2,0-3.7,1.6-3.7,3.7c0-2-1.6-3.7-3.7-3.7s-3.7,1.3-3.7,3.7 C68.2,78,73.7,80.1,75.7,87.4z"
}));

var _ref10 = /*#__PURE__*/React.createElement("g", {
  id: "ten"
}, /*#__PURE__*/React.createElement("path", {
  d: "M61,120.5c2,7.3,7.4,9.4,7.3,14.3c0,2.3-1.6,3.7-3.7,3.7c-2,0-3.7-1.6-3.7-3.7c0,2-1.6,3.7-3.7,3.7s-3.7-1.3-3.7-3.7 C53.6,129.9,59,127.8,61,120.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61,70.5c2-7.3,7.4-9.4,7.3-14.3c0-2.3-1.6-3.7-3.7-3.7c-2,0-3.7,1.6-3.7,3.7c0-2-1.6-3.7-3.7-3.7s-3.7,1.3-3.7,3.7 C53.6,61.1,59,63.2,61,70.5z"
}));

var _ref11 = /*#__PURE__*/React.createElement("g", {
  id: "base"
}, /*#__PURE__*/React.createElement("rect", {
  className: "st0",
  width: 122,
  height: 191
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.7,73.9c3-11,11.2-14.1,11-21.5c0-3.5-2.5-5.5-5.5-5.5s-5.5,2.5-5.5,5.5c0-3-2.5-5.5-5.5-5.5s-5.5,2-5.5,5.5 C8.5,59.8,16.7,62.9,19.7,73.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M101.7,116.9c3,11,11.2,14.1,11,21.5c0,3.5-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0,3-2.5,5.5-5.5,5.5s-5.5-2-5.5-5.5 C90.5,130.9,98.7,127.9,101.7,116.9z"
}));

var _ref12 = /*#__PURE__*/React.createElement("g", {
  id: "ace"
}, /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.5 -0.866 0.866 0.5 -54.8596 108.4135)",
  cx: 66.5,
  cy: 101.7,
  rx: 0.7,
  ry: 1.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M63.1,112.3c1.7-1.4,2.9-3,3-4.5c-0.9,0.5-2.1,0.9-3.4,1c-0.9-4.2-3.1-9-6.6-14.1c5.5,0.4,11.1,2.5,16.4,5.9 c5.4-7.1,10.4-12.6,10.2-20.6c0-6.7-4.7-10.8-10.8-10.8C66,69.2,61,73.8,61,80c0-5.9-4.7-10.8-10.8-10.8C44,69.2,39.3,73,39.3,80 c0.3,14.2,15.1,20.1,21.3,39.8C62.4,117.8,63.2,115.3,63.1,112.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.2,121.7c0,0,0,0.1,0,0.1C61.3,121.8,61.3,121.7,61.2,121.7C61.3,121.7,61.3,121.7,61.2,121.7z"
}));

var SvgHearts = function SvgHearts(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122 191",
    style: {
      enableBackground: "new 0 0 122 191"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHearts, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hearts.98903eda.svg";
export { ForwardRef as ReactComponent };